import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-gray-300">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_chaitra-property-reg/artifacts/bd0963e6_ChatGPT%20Image%20Mar%201%2C%202026%2C%2011_14_27%20PM.png" 
              alt="Chaitra Enterprises" 
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 leading-relaxed mb-4">
              Leading property registration and legal documentation services in Bengaluru with 20+ years of trusted excellence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })} className="hover:text-emerald-400 transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })} className="hover:text-emerald-400 transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('process').scrollIntoView({ behavior: 'smooth' })} className="hover:text-emerald-400 transition-colors">
                  Our Process
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('faq').scrollIntoView({ behavior: 'smooth' })} className="hover:text-emerald-400 transition-colors">
                  FAQ
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })} className="hover:text-emerald-400 transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-3 text-sm">
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Property Registration</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Sale Deeds & Agreements</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Legal Documentation</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Property Consultancy</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Stamp Duty Guidance</li>
              <li className="hover:text-emerald-400 transition-colors cursor-pointer">Title Verification</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-emerald-500 flex-shrink-0 mt-1" />
                <span className="text-sm">
                  515, 1st Cross Rd, Umarbagh Layout, Banashankari, Bengaluru - 560070
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-emerald-500 flex-shrink-0" />
                <div className="text-sm">
                  <a href="tel:+918217026707" className="block hover:text-emerald-400 transition-colors">
                    +91 82170 26707
                  </a>
                  <a href="tel:+917411026699" className="block hover:text-emerald-400 transition-colors">
                    +91 74110 26699
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-emerald-500 flex-shrink-0 mt-1" />
                <a href="mailto:chaitraenterprisesbsk@gmail.com" className="text-sm hover:text-emerald-400 transition-colors break-all">
                  chaitraenterprisesbsk@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p className="text-gray-400">
              © {currentYear} Chaitra Enterprises. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-emerald-400 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-emerald-400 transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
